import {Modal} from 'bootstrap';

export class AddPortfolio {
    constructor(button, form){
        this.button = button;
        this.modalElement = document.querySelector('#page-modal');
        this.modalElement.querySelector('.modal-title').textContent = button.dataset.title;
        this.modal = new Modal(this.modalElement);
        this.pageForm = document.createElement('form');
        this.pageForm.className = 'page-form';
        this.pageForm.action = button.dataset.submit;
        this.pageForm.innerHTML = form;
        this.pageFormContainer = document.querySelector('#page-form-container');
        this.pageFormContainer.innerHTML = '';
        this.pageFormContainer.appendChild(this.pageForm);
        this.pageForm.addEventListener('submit', this.submitEvent.bind(this));
        this.modal.show();
    }
    submitEvent(e){
        e.preventDefault();
        let formData = new FormData(this.pageForm);
        fetch(this.pageForm.action, {
            method: 'post',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            this.modal.hide();
            this.submitCallback(data);
        });
    }
    submitCallback(data){
        let content= `
            <div class="card h-100 border-0 p-0">
                <div class="card-body thumbnail" style="background-image:url('/img/jpg/portfolio/thumbnails/${data.image}');">
                    <a href="/img/jpg/portfolio/originals/${data.image}" class="glightbox">
                    </a>
                </div>
                <div class="card-footer bg-white">
                    <nav class="nav nav-fill">
                        <a class="nav-link"href="#" data-id="${data.id}">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil text-primary" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z"/>
                                <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z"/>
                            </svg>       
                        </a>
                        <a class="nav-link delete-button" href="#" data-id="${data.id}" data-title="Delete item" data-submit="/admin/portfolio/delete">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-trash text-danger" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>     
                        </a>
                    <nav>
                </div>
            </div>
        `;
        let itemsContainer = document.querySelector('.items-container');
        let div = document.createElement('div');
        div.classList = 'col-lg-3 item';
        div.innerHTML = content;
        itemsContainer.appendChild(div);
    }
}